import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";
import Styles from "./BilateralSearch.module.css";
import { useDispatch, useSelector } from "react-redux";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CallMadeOutlinedIcon from "@mui/icons-material/CallMadeOutlined";
import { ReactComponent as Download } from "../../assets/images/downloadFile.svg";

import { Slider } from "@mui/material";
import ReactDOM from "react-dom";

import { formatDateType } from "../../commons/FormatDate";
import ViewInjectionModal from "../Modals/ConGen/ViewInjectionModal/ViewInjectionModal";
import ConGenListingModal from "../Modals/ConGen/ConGenListingModal";
import { createListing, placeBidApi } from "../../Services/BuySell/Creation";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { Skeleton } from "@mui/material";
import {
  getAllCreditRating,
  getAllRegion,
} from "../../Services/ApiCalling/PublicApi";
import TimeInput from "../../commons/Inputs/TimeInputBailateral/TimeInput";
import {
  fetchSearchListing,
  setSearchListype,
} from "../../Redux/Slices/CapacitySlice";
import PreviewModal from "../../commons/PreviewModal/PreviewModal";
import { getDocumentUrlByLedgerId } from "../../Services/ApiCalling/banking";
import { downloadListing } from "../../Services/ApiCalling/Listing";
import { toast } from "react-toastify";
import LoadMorePagination from "../LoadeMore";

const BilateralSearch = () => {
  const searchList = useSelector(
    (state) => state?.CapacitySlice?.searchListing,
  );
  const user = useSelector(
    (state) => state.persistedReducer.user?.activeRole,
  )?.toLowerCase();
  const [item, setItem] = useState([]);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const [listype, setListype] = useState(false); // false for interstate, true for intrastate
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [createListingDataLoading, setCreateListingDataLoading] =
    useState(false);
  const userData = useSelector((state) => state?.persistedReducer);

  const activeRole = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  )?.toLowerCase();
  const consumerList = useSelector(
    (state) => state?.persistedReducer?.consumer,
  );
  const generatorList = useSelector(
    (state) => state?.persistedReducer?.generator,
  );
  // Pick the stateLabel of the active entity based on the active role
  const entityList = activeRole === "consumer" ? consumerList : generatorList;
  const activeEntity =
    entityList?.find((ele) => ele?.isActive) || entityList?.[0];
  const state = activeEntity?.stateLabel;
  const token = useSelector((state) => state?.persistedReducer?.token);
  const energyList = useSelector(
    (state) => state?.publicSlice?.publicEnergyType,
  );

  const scrollRef = useRef(null);
  const scrollPos = useRef(0);
  // Monotonic request id. Every fetch stamps its intended (listype, state, page)
  // so a stale in-flight response (e.g. from a previous tab, or a background
  // notification refresh) can never overwrite the currently-visible tab's data.
  const requestKeyRef = useRef("");

  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const dispatch = useDispatch();

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [regionList, setRegionList] = useState([]);
  const [energyTypeOpen, setEnergyTypeOpen] = useState(false);
  const [regionOpen, setRegionOpen] = useState(false);
  const energyTypeRef = useRef(null);
  const regionRef = useRef(null);

  const [filterDraft, setFilterDraft] = useState({
    quantity: [0, 10000],
    energyRate: [0, 200],
    creditRating: "",
    energyType: [],
    region: [],
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
  });

  useEffect(() => {
    setPage(0);
    setItem([]);
    setHasMore(true);
    // Keep the store in sync so the notification handler refreshes only the
    // tab currently being viewed (both types share the searchListing slot).
    dispatch(setSearchListype(listype));
  }, [listype, dispatch]);

  // Reflect background updates to the shared searchListing slot (e.g. a
  // notification refresh) only when they belong to the tab currently shown.
  // The reducer stores the raw page array for whichever type was fetched last;
  // guard with requestKeyRef so a stale/other-tab payload can't leak in.
  useEffect(() => {
    if (page !== 0) return;
    const currentKey = `${listype}-${state}-0`;
    if (requestKeyRef.current !== currentKey) return;
    setItem(Array.isArray(searchList) ? searchList : []);
  }, [searchList, listype, state, page]);

  const tabKey = `${listype}-${state}`;

  useEffect(() => {
    setPage(0);
    setItem([]);
    scrollPos.current = 0;
  }, [tabKey]);

  const [errors, setErrors] = useState({});
  const [ratingsList, setRatingsList] = useState([]);

  useEffect(() => {
    const id = setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollPos.current;
      }
    }, 50);

    return () => clearTimeout(id);
  }, [item]);

  const handleLoadMore = () => {
    if (scrollRef.current) {
      scrollPos.current = scrollRef.current.scrollTop;
    }
    setPage((prev) => prev + 1);
  };

  const [filterState, setFilterState] = useState({
    quantity: [0, 10000],
    energyRate: [0, 200],
    creditRating: "",
    energyType: [],
    region: [],
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
  });

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const handleRegion = useCallback(async () => {
    const res = await getAllRegion(token);
    if (res?.data?.code === 200) {
      setRegionList(res?.data?.data);
    }
  }, [token]);

  useEffect(() => {
    handleRegion();
  }, [handleRegion]);

  useEffect(() => {
    if (!energyTypeOpen) return;
    const handler = (e) => {
      if (energyTypeRef.current && !energyTypeRef.current.contains(e.target))
        setEnergyTypeOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [energyTypeOpen]);

  useEffect(() => {
    if (!regionOpen) return;
    const handler = (e) => {
      if (regionRef.current && !regionRef.current.contains(e.target))
        setRegionOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [regionOpen]);

  async function getCreditRatinga() {
    try {
      const ratings = await getAllCreditRating();
      if (ratings?.data?.code === 200) {
        setRatingsList(ratings?.data?.data || []);
      }
    } catch (error) {}
  }

  useEffect(() => {
    getCreditRatinga();
  }, []);

  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  )?.toLowerCase();

  const loader = useSelector(
    (state) => state?.CapacitySlice?.searchListingLoading,
  );

  const [viewReqData, setViewReqData] = useState(null);
  const [connectData, setConnectData] = useState(null);

  useEffect(() => {
    if (!role) return;

    // Stamp this request. Any response whose key no longer matches the current
    // tab/state/page is stale and must be discarded (prevents an old interstate
    // fetch from repopulating the table after switching to an empty intrastate).
    const requestKey = `${listype}-${state}-${page}`;
    requestKeyRef.current = requestKey;

    const fetchSearchList = async () => {
      try {
        let aa = role === "consumer" ? "generator" : "consumer";

        const response = await dispatch(
          fetchSearchListing({
            user: aa,
            curr: page,
            type: listype,
            state,
            size: 30,
          }),
        ).unwrap();

        // Ignore responses that arrived after the user moved to another tab/state.
        if (requestKeyRef.current !== requestKey) return;

        // The thunk returns { data: <the paginated object> }, where that object
        // is { totalElements, totalPages, currentPage, page: [...] }.
        const pageData = response?.data;
        const rows = Array.isArray(pageData?.page) ? pageData.page : [];
        const { totalPages, currentPage } = pageData || {};

        if (page === 0) {
          setItem(rows);
        } else {
          setItem((prev) => [...prev, ...rows]);
        }
        setHasMore((currentPage ?? 0) < (totalPages ?? 0) - 1);
      } catch (error) {}
    };

    fetchSearchList();
  }, [role, page, state, listype, dispatch]);

  const handleDirectConnect = async (id) => {
    let payload = {
      initiator: role,
      capacityConsumerId: role === "consumer" ? id : connectData?.id,
      capacityGeneratorId: role === "generator" ? id : connectData?.id,
      reason: "PRICE",
    };
    const response = await placeBidApi(payload);
    if (response?.data?.code === 200) {
      setConnectData(false);
      window.location.href = "/dashboard";
    }
  };

  const createUserListing = async (payload) => {
    try {
      setCreateListingDataLoading(true);
      let res = await createListing(payload, role);
      if (res?.data?.code === 200) {
        handleDirectConnect(res?.data?.data?.id);
      }
    } catch (error) {
    } finally {
      setCreateListingDataLoading(false);
    }
  };

  const skeletonRows = Array.from({ length: 5 });
  const filterRef = useRef(null);

  useEffect(() => {
    if (!isFilterOpen) {
      setErrors({}); // Reset errors when modal closes
      return;
    }

    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setIsFilterOpen(false);
        setErrors({}); // Reset errors when modal closes
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isFilterOpen]);

  const validateFields = (state) => {
    const newErrors = {};

    // Quantity validation
    if (state.quantity[0] > state.quantity[1]) {
      newErrors.quantity = "Min quantity cannot be greater than max quantity";
    }

    // Energy Rate validation
    if (state.energyRate[0] > state.energyRate[1]) {
      newErrors.energyRate = "Min rate cannot be greater than max rate";
    }

    // Dates validation
    if (state.startDate && state.endDate && state.startDate > state.endDate) {
      newErrors.startDate = "Start date cannot be after end date";
      newErrors.endDate = "End date cannot be before start date";
    }

    // Time validation
    if (state.startTime && state.endTime && state.startTime >= state.endTime) {
      newErrors.startTime = "Start time must be before end time";
      newErrors.endTime = "End time must be after start time";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    if (!isFilterOpen) return;

    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setIsFilterOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isFilterOpen]);

  async function handleDownload(data) {
    try {
      const response = await downloadListing(data.id, true);
      const blob = response.data;
      const url = window.URL.createObjectURL(
        new Blob([blob], {
          type: "application/pdf",
        }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `listing_${data.name}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Listing downloaded successfully!");
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to download listing.",
      );
    }
  }

  const filterListings = useCallback(
    (list) => {
      const filtered = (list ?? []).filter((ele) => {
        if (ele?.listingMode !== "BILATERAL") return false;
        if (
          filterState.energyType.length > 0 &&
          !filterState.energyType.includes(ele?.energyFuelType)
        )
          return false;
        if (
          filterState.region.length > 0 &&
          !filterState.region.includes(ele?.region)
        )
          return false;
        return true;
      });

      if (!sortConfig.key) return filtered;
      return [...filtered].sort((a, b) => {
        const aVal = a[sortConfig.key] ?? "";
        const bVal = b[sortConfig.key] ?? "";
        if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
        if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    },
    [filterState, sortConfig],
  );

  const handleViewTermsDocument = async (termsDocumentId) => {
    if (!termsDocumentId || termsDocumentId === 0) {
      return;
    }

    try {
      const response = await getDocumentUrlByLedgerId(termsDocumentId);
      const url = response?.data || response;
      if (url) {
        setPreviewFileUrl(url);
        setPreviewModal(true);
      } else {
      }
    } catch (error) {}
  };

  const tableColumns = [
    { name: "Listing Id", width: "20%" },
    { name: "Buy/Sell Requisitions", width: "15%" },
    { name: "Energy Type", width: "15%" },
    { name: "Supply Region", width: "15%" },
    { name: "Specific T&C", width: "20%" },
    { name: "Listing Expiry", width: "20%" },
    { name: "Comment", width: "200px" },
    { name: "Action", width: "200px" },
  ];

  const handleClosePreview = () => {
    setPreviewModal(false);
    setPreviewFileUrl(null);
  };

  return (
    <>
      <ViewInjectionModal
        open={viewReqData}
        handleClose={() => setViewReqData(null)}
        data={viewReqData}
      />
      {connectData && (
        <ConGenListingModal
          data={connectData}
          open={connectData}
          directConnect={true}
          handleClose={() => setConnectData(null)}
          handleSubmit={createUserListing}
          loading={createListingDataLoading}
          type={"search"}
        />
      )}

      {previewModal && (
        <PreviewModal
          open={previewModal}
          onClose={handleClosePreview}
          fileUrl={previewFileUrl}
          name="Terms and Conditions"
        />
      )}
      {isFilterOpen &&
        ReactDOM.createPortal(
          <div ref={filterRef} className={Styles.filterDropdown}>
            <div className={Styles.filterHeader}>
              <span>Filters</span>
            </div>
            <div className={Styles.filterContent}>
              <div>
                <div
                  style={{
                    background: "white",
                    padding: "20px",
                    borderRadius: "12px",
                  }}
                  className={Styles.filterRow}
                >
                  {/* Quantity */}
                  <div className={Styles.filterField}>
                    <label>Quantity (MW)</label>
                    <div className={Styles.rangeSlider}>
                      <div className={Styles.rangeValues}>
                        <span>{filterDraft.quantity[0]}</span>
                        <span>{filterDraft.quantity[1]}</span>
                      </div>
                      <Slider
                        value={filterDraft.quantity}
                        onChange={(e, newValue) =>
                          setFilterDraft({
                            ...filterDraft,
                            quantity: newValue,
                          })
                        }
                        min={0}
                        max={10000}
                        valueLabelDisplay="auto"
                        sx={{
                          color: "var(--primary-color-text)",
                          "& .MuiSlider-thumb": {
                            width: 18,
                            height: 18,
                            fontSize: "12px",
                            backgroundColor: "var(--primary-color-text)",
                            border: "3px solid white",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                            "&:hover, &.Mui-focusVisible": {
                              boxShadow: "0 0 0 8px rgba(255, 107, 53, 0.16)",
                            },
                          },
                          "& .MuiSlider-track": {
                            height: 6,
                            border: "none",
                          },
                          "& .MuiSlider-rail": {
                            height: 6,
                            opacity: 0.3,
                            backgroundColor: "#ddd",
                          },
                        }}
                      />
                    </div>
                    {errors.quantity && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.quantity}
                      </div>
                    )}
                  </div>

                  {/* Energy Rate */}
                  <div className={Styles.filterField}>
                    <label>Energy Rate (kWh)</label>
                    <div className={Styles.rangeSlider}>
                      <div className={Styles.rangeValues}>
                        <span>{filterDraft.energyRate[0]}</span>
                        <span>{filterDraft.energyRate[1]}</span>
                      </div>
                      <Slider
                        value={filterDraft.energyRate}
                        onChange={(e, newValue) =>
                          setFilterDraft({
                            ...filterDraft,
                            energyRate: newValue,
                          })
                        }
                        min={0}
                        max={200}
                        valueLabelDisplay="auto"
                        sx={{
                          color: "var(--primary-color-text)",
                          "& .MuiSlider-thumb": {
                            width: 18,
                            height: 18,
                            backgroundColor: "var(--primary-color-text)",
                            border: "3px solid white",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                            "&:hover, &.Mui-focusVisible": {
                              boxShadow: "0 0 0 8px rgba(255, 107, 53, 0.16)",
                            },
                          },
                          "& .MuiSlider-track": {
                            height: 6,
                            border: "none",
                          },
                          "& .MuiSlider-rail": {
                            height: 6,
                            opacity: 0.3,
                            backgroundColor: "#ddd",
                          },
                        }}
                      />
                    </div>
                    {errors.energyRate && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.energyRate}
                      </div>
                    )}
                  </div>

                  {/* Credit Rating */}
                  <div className={Styles.filterField}>
                    <label>Credit Rating</label>
                    <select
                      value={filterDraft.creditRating}
                      onChange={(e) =>
                        setFilterDraft({
                          ...filterDraft,
                          creditRating: e.target.value,
                        })
                      }
                    >
                      <option value="">Select</option>
                      {ratingsList.map((rating) => (
                        <option key={rating.id} value={rating.rating}>
                          {rating.rating}
                        </option>
                      ))}
                    </select>
                    {errors.creditRating && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.creditRating}
                      </div>
                    )}
                  </div>

                  {/* Energy Type */}
                  <div
                    className={Styles.filterField}
                    style={{ position: "relative" }}
                    ref={energyTypeRef}
                  >
                    <label>Energy Type</label>
                    <div
                      onClick={() => setEnergyTypeOpen((p) => !p)}
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "6px 10px",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: "white",
                        fontSize: "13px",
                        minHeight: "34px",
                      }}
                    >
                      <span
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          color:
                            filterDraft.energyType.length === 0
                              ? "#888"
                              : "inherit",
                        }}
                      >
                        {filterDraft.energyType.length === 0
                          ? "All"
                          : filterDraft.energyType.join(", ")}
                      </span>
                      <span
                        style={{
                          fontSize: "10px",
                          flexShrink: 0,
                          marginLeft: "6px",
                        }}
                      >
                        {energyTypeOpen ? "▲" : "▼"}
                      </span>
                    </div>
                    {energyTypeOpen && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          right: 0,
                          background: "white",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                          zIndex: 200,
                          maxHeight: "200px",
                          overflowY: "auto",
                          marginTop: "2px",
                        }}
                      >
                        {!energyList?.length ? (
                          <div
                            style={{
                              padding: "8px 12px",
                              fontSize: "13px",
                              color: "#888",
                            }}
                          >
                            No options
                          </div>
                        ) : (
                          energyList.map((t) => (
                            <label
                              key={t.id}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                padding: "8px 12px",
                                cursor: "pointer",
                                fontSize: "13px",
                                background: filterDraft.energyType.includes(
                                  t.type,
                                )
                                  ? "#fff4f0"
                                  : "white",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={filterDraft.energyType.includes(
                                  t.type,
                                )}
                                onChange={(e) => {
                                  const updated = e.target.checked
                                    ? [...filterDraft.energyType, t.type]
                                    : filterDraft.energyType.filter(
                                        (x) => x !== t.type,
                                      );
                                  setFilterDraft({
                                    ...filterDraft,
                                    energyType: updated,
                                  });
                                }}
                              />
                              {t.type}
                            </label>
                          ))
                        )}
                      </div>
                    )}
                  </div>

                  {/* Region */}
                  <div
                    className={Styles.filterField}
                    style={{ position: "relative" }}
                    ref={regionRef}
                  >
                    <label>Region</label>
                    <div
                      onClick={() => setRegionOpen((p) => !p)}
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "6px 10px",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: "white",
                        fontSize: "13px",
                        minHeight: "34px",
                      }}
                    >
                      <span
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          color:
                            filterDraft.region.length === 0
                              ? "#888"
                              : "inherit",
                        }}
                      >
                        {filterDraft.region.length === 0
                          ? "All"
                          : filterDraft.region.join(", ")}
                      </span>
                      <span
                        style={{
                          fontSize: "10px",
                          flexShrink: 0,
                          marginLeft: "6px",
                        }}
                      >
                        {regionOpen ? "▲" : "▼"}
                      </span>
                    </div>
                    {regionOpen && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          right: 0,
                          background: "white",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                          zIndex: 200,
                          maxHeight: "200px",
                          overflowY: "auto",
                          marginTop: "2px",
                        }}
                      >
                        {!regionList?.length ? (
                          <div
                            style={{
                              padding: "8px 12px",
                              fontSize: "13px",
                              color: "#888",
                            }}
                          >
                            No options
                          </div>
                        ) : (
                          regionList.map((r) => (
                            <label
                              key={r.id}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                padding: "8px 12px",
                                cursor: "pointer",
                                fontSize: "13px",
                                background: filterDraft.region.includes(r.name)
                                  ? "#fff4f0"
                                  : "white",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={filterDraft.region.includes(r.name)}
                                onChange={(e) => {
                                  const updated = e.target.checked
                                    ? [...filterDraft.region, r.name]
                                    : filterDraft.region.filter(
                                        (x) => x !== r.name,
                                      );
                                  setFilterDraft({
                                    ...filterDraft,
                                    region: updated,
                                  });
                                }}
                              />
                              {r.name}
                            </label>
                          ))
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div
                  style={{
                    background: "white",
                    padding: "20px",
                    borderRadius: "12px",
                    marginTop: "15px",
                  }}
                  className={Styles.filterRow}
                >
                  {/* Start Date */}
                  <div className={Styles.filterField}>
                    <label>Start Date</label>
                    <input
                      type="date"
                      value={filterDraft.startDate}
                      onChange={(e) =>
                        setFilterDraft({
                          ...filterDraft,
                          startDate: e.target.value,
                        })
                      }
                    />
                    {errors.startDate && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.startDate}
                      </div>
                    )}
                  </div>

                  {/* End Date */}
                  <div className={Styles.filterField}>
                    <label>End Date</label>
                    <input
                      type="date"
                      value={filterDraft.endDate}
                      onChange={(e) =>
                        setFilterDraft({
                          ...filterDraft,
                          endDate: e.target.value,
                        })
                      }
                    />
                    {errors.endDate && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.endDate}
                      </div>
                    )}
                  </div>

                  {/* Start Time */}
                  <div className={Styles.filterField}>
                    <TimeInput
                      noTooltip={true}
                      isRtc={false}
                      type={"startTime"}
                      heading={"Start Time"}
                      value={filterDraft.startTime}
                      onChange={(value) =>
                        setFilterDraft({
                          ...filterDraft,
                          startTime: value,
                        })
                      }
                      startDate={filterDraft.startDate}
                      minutesStep={15}
                      height={35}
                    />
                    {errors.startTime && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.startTime}
                      </div>
                    )}
                  </div>

                  {/* End Time */}
                  <div className={Styles.filterField}>
                    <TimeInput
                      isRtc={false}
                      type={"endTime"}
                      heading={"End Time"}
                      value={filterDraft.endTime}
                      onChange={(value) =>
                        setFilterDraft({
                          ...filterDraft,
                          endTime: value,
                        })
                      }
                      startDate={filterDraft.endDate}
                      minutesStep={15}
                      height={35}
                    />
                    {errors.endTime && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.endTime}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className={Styles.filterActions}>
                <button
                  className={Styles.resetButton}
                  onClick={() => {
                    const reset = {
                      quantity: [0, 10000],
                      energyRate: [0, 100],
                      creditRating: "",
                      energyType: [],
                      region: [],
                      startDate: "",
                      endDate: "",
                      startTime: "",
                      endTime: "",
                    };
                    setFilterDraft(reset);
                    setFilterState(reset);
                  }}
                >
                  Reset
                </button>
                <button
                  className={Styles.applyButton}
                  onClick={() => {
                    if (validateFields(filterDraft)) {
                      setFilterState(filterDraft);
                      setIsFilterOpen(false);
                    }
                  }}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>,
          document.body,
        )}

      <div className={Styles.searchMainContainer}>
        <div className={`display_flex_row ${Styles.searchHeaderContainer}`}>
          <div className="display_flex_row_gap_8_only">
            <div
              onClick={() => window.history.back()}
              className={`display_flex_row_gap_4_only ${Styles.backElem}`}
            >
              <ArrowBackIosIcon style={{ fontSize: "12px" }} />
              <span>Back</span>
            </div>
            <div className={Styles.availableHeading}>
              {user === "consumer"
                ? "All Available Sell Listings"
                : "All Available Buy Listings"}{" "}
              {/* All Available Matching Listing */}
            </div>
          </div>
          <div className="display_flex_row_gap_8_only">
            <div className={Styles.buttonContainerMain}>
              <div
                className={!listype && Styles.activeButton}
                onClick={() => setListype(false)}
              >
                Interstate
              </div>
              <div
                className={listype && Styles.activeButton}
                onClick={() => setListype(true)}
              >
                Intrastate
              </div>
            </div>
            <div
              className={`display_flex_row_center  ${Styles.filterButton}`}
              onClick={() => {
                setFilterDraft(filterState);
                setIsFilterOpen(true);
              }}
              onMouseDown={
                isFilterOpen ? (e) => e.stopPropagation() : undefined
              }
            >
              <span>Filter</span>
              <ExpandMoreIcon
                style={{
                  fontSize: "16px",
                  transform: isFilterOpen ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              />
            </div>
          </div>
        </div>
        <div className={Styles.listingMainContainer}>
          <div
            ref={scrollRef}
            className={`scroll_bar_y ${Styles.tableContainer}`}
          >
            <LoadMorePagination
              hasMore={hasMore}
              onLoadMore={handleLoadMore}
              loading={loader}
              hideLoadmore={filterListings(item)?.length === 0}
            >
              <table className={Styles.dataTable}>
                <thead>
                  <tr className="tableHeading">
                    {tableColumns.map((col, idx) => (
                      <th key={idx} style={{ width: col.width }}>
                        {col.name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    skeletonRows.map((_, idx) => (
                      <tr key={idx} className="tableDetails">
                        {tableColumns.map((_, colIdx) => (
                          <td key={colIdx}>
                            <Skeleton variant="rectangular" height={32} />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : filterListings(item)?.length === 0 ? (
                    <tr>
                      <td colSpan={tableColumns.length}>
                        <div
                          className={`display_flex_row_center ${Styles.noListings}`}
                        >
                          No {listype ? "Intrastate" : "Interstate"} listings
                          found
                        </div>
                      </td>
                    </tr>
                  ) : (
                    filterListings(item)?.map((data, idx) => (
                      <tr key={data?.id || idx} className="tableDetails">
                        <td style={{ textAlign: "center" }}>{data?.name}</td>
                        <td style={{ textAlign: "center" }}>
                          <span
                            className={Styles.viewReq}
                            onClick={() => setViewReqData(data)}
                          >
                            View Details
                          </span>
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {data?.energyFuelType}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {data?.region || "-"}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <button
                            title={
                              data.termsDocumentId
                                ? "View Specific T&C"
                                : "Specific T&C not available"
                            }
                            onClick={(e) => {
                              e.stopPropagation();
                              handleViewTermsDocument(data.termsDocumentId);
                            }}
                            disabled={!data.termsDocumentId}
                            className={Styles.tandContainer}
                            style={{
                              cursor: data.termsDocumentId
                                ? "pointer"
                                : "not-allowed",
                              opacity: data.termsDocumentId ? 1 : 0.6,
                            }}
                          >
                            <span>View Specific T&C</span>
                            <CallMadeOutlinedIcon
                              style={{ fontSize: "10px", marginTop: "-10px" }}
                            />
                          </button>
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {formatDateType(data?.listingExpDate)}{" "}
                          {data?.listingExpTime}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <span
                            title={data?.comment || "-"}
                            style={{
                              display: "inline-block",
                              maxWidth: "200px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {data?.comment || "-"}
                          </span>
                        </td>
                        <td>
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              alignItems: "center",
                            }}
                          >
                            <button
                              className={`activeButton ${Styles.connectButton}`}
                              onClick={() => setConnectData(data)}
                            >
                              Connect
                            </button>

                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => handleDownload(data)}
                            >
                              <Download />
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </LoadMorePagination>
          </div>
        </div>
      </div>
    </>
  );
};

export default BilateralSearch;
